import { render, staticRenderFns } from "./OrderProductSizesForExchange.vue?vue&type=template&id=0e905eda&"
import script from "./OrderProductSizesForExchange.vue?vue&type=script&lang=js&"
export * from "./OrderProductSizesForExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports